<section class="cz-user-profile-dialog">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
          <h3 class="title">{{(addUser ? '$header_create_user' : '$commom_user_profile') | translate}}</h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div class="row">
      <div class="col-xs-10" *ngIf="user.id > 0">
          <h2 class="page-title row middle-xs">
            <div class="col-xs middle-xs">
              <span class="profile-badge">
                <span>{{ user | userInitials }}</span>
              </span>
              <span class="profile-name">{{ user?.firstName }} {{ user?.lastName }}</span>
            </div>
          </h2>
      </div>
      <div class="col-xs-2 end-xs" *ngIf="user.id > 0 && !isEmployee">
        <button mat-icon-button [matMenuTriggerFor]="userMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="createTaskForUser()" [innerHTML]="'$common_create_a_task' | translate"></button>
          <button mat-menu-item (click)="sendNotificationToUser()" [innerHTML]="'$lng_send_email_but' | translate"></button>
          <button mat-menu-item (click)="goToUserDetails()" [innerHTML]="'$btn_go_to_user_details' | translate"></button>
        </mat-menu>
      </div>
    </div>
    <section class="user-details-profile" *ngIf="loadComplete">
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="truncate">
            <span class="truncate">{{'$header_profile' | translate}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [formGroup]="detailsForm">
          <div class="row">
            <div class="col-xs-4">
              <mat-form-field class="form-full-width-field">
                <mat-label >{{'$common_username' | translate}}*</mat-label>
                <input matInput formControlName="usernameControl" (keyup)="checkUserNameValue($event)"/>
                <mat-error *ngIf="userNameControl.hasError('invalid')" [innerHTML]="'$profile_user_unique_username_error' | translate">
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-xs-4">
              <mat-form-field class="form-full-width-field">
                <mat-label>{{'$common_user_role' | translate}}*</mat-label>
                <mat-select matInput formControlName="userRoleControl">
                  <mat-option *ngFor="let role of userRoleData" [value]="role.id">{{role.description}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-xs-4">
              <mat-slide-toggle [checked]="!user.userDisabled"
                                (change)="updateDisabled($event)"
                                [disabled]="detailsForm.disabled || this.isEmployee">{{'$user_details_details_section_has_access' | translate}}</mat-slide-toggle>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-4">
              <mat-form-field class="form-full-width-field">
                <mat-label>{{'$common_first_name' | translate}}*</mat-label>
                <input matInput formControlName="firstNameControl">
              </mat-form-field>
            </div>
            <div class="col-xs-4">
              <mat-form-field class="form-full-width-field">
                <mat-label>{{'$common_last_name' | translate}}*</mat-label>
                <input matInput formControlName="lastNameControl">
              </mat-form-field>
            </div>
            <div class="col-xs-4">
              <mat-form-field class="form-full-width-field">
                <mat-label>{{'$common_email' | translate}}*</mat-label>
                <input matInput type="email" formControlName="emailControl">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-4">
              <mat-form-field class="form-full-width-field">
                <mat-label>{{'$common_phone' | translate}}*</mat-label>
                <input matInput type="tel" formControlName="phoneControl">
              </mat-form-field>
            </div>
            <div class="col-xs-4">
              <mat-form-field class="form-full-width-field">
                <mat-label>{{'$common_gender' | translate}}</mat-label>
                <mat-select formControlName="genderControl">
                  <mat-option [value]="2">{{'$common_male' | translate}}</mat-option>
                  <mat-option [value]="1">{{'$common_female' | translate}}</mat-option>
                  <mat-option [value]="3">{{'$common_n_a' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-xs-4">
              <button mat-stroked-button *ngIf="resetPasswordButton && !this.isEmployee && !addUser" color="accent" (click)="openResetPassword()" [innerHTML]="'$btn_reset_password' | translate" ></button>
            </div>
            <div class="col-xs-4" *ngIf="_GlobalConstants.ssoActive">
              <mat-slide-toggle [checked]="user.ssoAccessOnly"
                                (change)="updateSSOAccess($event)"
                                [disabled]="detailsForm.disabled || this.isEmployee">{{'$sso_access_only' | translate}}</mat-slide-toggle>
            </div>
          </div>
        </div>
        <section class="filter-section" *ngIf="siteFilters && siteFilters.length > 0">
          <div class="row">
            <div class="col-xs">
              <h5>{{'$site_filter_title' | translate}}</h5>
            </div>
          </div>
          <div class="row" [formGroup]="filterForm">
            <div class="col-xs-4" *ngFor="let filter of siteFilters">
              <p>
                <mat-form-field>
                  <mat-label>{{filter.name}}</mat-label>
                  <mat-select formControlName="{{filter.id}}">
                    <mat-option *ngFor="let item of filter.items" [value]="item.id">{{item.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </p>
            </div>
          </div>
        </section>
        <section class="custom-field-section" *ngIf="customFields && customFields.length > 0">
          <div class="row">
            <div class="col-xs">
              <h5>{{'$custom_fields' | translate}}</h5>
            </div>
          </div>
          <div class="row" [formGroup]="customFieldForm">
            <div class="col-xs-4" *ngFor="let customField of customFields">
              <p>
                <mat-form-field class="form-full-width-field" [floatLabel]="customFieldsFloatState">
                  <mat-label>{{customField.label}}</mat-label>
                  <input matInput placeholder="{{'$common_not_answered' | translate}}"
                                  formControlName="{{customField.id}}"/>
                </mat-form-field>
              </p>
            </div>
          </div>
        </section>

        <div class="row" *ngIf="saveComplete && !addUser">
          <div class="col-xs center-xs">
            <p class="saved-alert text-error" [innerHTML]="'$profile_user_changes_note' | translate"></p>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel expanded="true" class="ergonomics-team" *ngIf="user.id > 0 && (canEditErgoTeam || ergoTeam?.length > 0)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="truncate">{{'$ergo_team' | translate}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-toolbar color="primary">
          <div class="row middle-xs">
            <div class="col-xs start-xs">
              <p>{{'$ergo_team_member' | translate}}</p>
            </div>
            <div class="col-xs">
              <p>{{'$ergo_team_role' | translate}}</p>
            </div>
            <div class="col-xs-1 end-xs">
              &nbsp;
            </div>
          </div>
        </mat-toolbar>
        <div class="team-container">
          <div class="row team-member middle-xs" *ngFor="let teamMember of ergoTeam">
            <div class="col-xs start-xs member-cell">
                <cz-user-name-link [user]="teamMember.memberUser"
                [config]="ergoTeamBadgeConfig"></cz-user-name-link>
            </div>
            <div class="col-xs role-cell">
              <p>{{teamMember.ergoRoleLabel}}</p>
            </div>
            <div class="col-xs-1 end-xs delete-member-btn">
              <button mat-icon-button color="error" (click)="deleteTeamMember(teamMember)" *ngIf="canEditErgoTeam">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="row add-team-member" *ngIf="canEditErgoTeam">
          <div class="col-xs">
            <cz-user-select *ngIf="adminUsersFiltered$ | async as adminUsersFiltered"
                            [users]="adminUsersFiltered"
                            [label]="'$ergo_team_select' | translate"
                            (onSelect)="ergoTeamSelected($event)"></cz-user-select>
          </div>
          <div class="col-xs">
            <mat-form-field *ngIf="ergoRoles" class="form-full-width-field">
              <mat-label>{{'$ergo_team_select_role' | translate}}</mat-label>
              <mat-select [formControl]="ergoTeamRoleControl">
                <mat-option *ngFor="let role of ergoRoles" [value]="role">
                  {{role.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xs-1">
            <button mat-icon-button
                    color="accent"
                    [disabled]="!(ergoTeamMemberControl.valid && ergoTeamRoleControl.valid)"
                    (click)="addErgoTeamMember()">
              <mat-icon>add_circle</mat-icon>
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </section>
  </mat-dialog-content>
  <mat-dialog-actions >

      <div class="row w-100">
        <div class="col-xs-6">
          <button mat-stroked-button mat-dialog-close>{{'$btn_close' | translate}}</button>
        </div>
        <div class="col-xs-6 text-right" *ngIf="canSave">
          <button mat-flat-button class="link"
                                  color="accent"
                                  [innerHTML]="'$btn_save' | translate"
                                  (click)="saveUser()"
                                  [disabled]="!detailsForm.valid && !userNameChecked"></button>
        </div>

      </div>

  </mat-dialog-actions>
</section>
